import { useClientPortalConfigContext } from "context/ClientPortalConfig.ctx";
import { useGetQuery } from "hooks/useClientPortalQuery";
import { CreditCardInfo } from "types/generated/models";

interface IClientCreditCardDetailsHook {
    creditCardInfo?: CreditCardInfo | null;
    isLoading: boolean;
}

export function useClientCreditCardDetails(practitionerId?: number): IClientCreditCardDetailsHook {
    const { clientPortalGuid, clientPortalConfig } = useClientPortalConfigContext();
    const params = new URLSearchParams();
    if (practitionerId) params.append("practitionerId", practitionerId.toString());
    const queryString = params.toString();
    const { data, isLoading = true } = useGetQuery<CreditCardInfo | null>({
        url: `/api/v1/${clientPortalGuid}/Stripe/GetCreditCard${queryString ? `?${queryString}` : ""}`,
        options: {
            enabled: clientPortalConfig?.userLoggedIn,
        },
    });

    return { creditCardInfo: data, isLoading };
}
